class ServiceReport {
  constructor(id, oil, brake, coolant, tires, lights, mileage) {
    this.id = id;
    this.oil = oil;
    this.brake = brake;
    this.coolant = coolant;
    this.tires = tires;
    this.lights = lights;
    this.mileage = mileage;
  }
}

export default ServiceReport;
